// import hooks
import { useTranslation } from "react-i18next";

// import components
import { Container } from "react-bootstrap";
import Carousel from "react-multi-carousel";

// import assets
import "react-multi-carousel/lib/styles.css";
import "../../assets/css/cards.css";
import { goldStar, star, dQoute } from "../../utils/cards-svgs";

// import data
import clientsOpinions from "../../utils/data/clientsOpinions";

const ClientsOpinions = () => {
    const [t] = useTranslation("global");
    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 2,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: {
                max: 576,
                min: 0
            },
            items: 1
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 576
            },
            items: 2,
            partialVisibilityGutter: 30
        }
    };
    return (
        <div className="clients-opinions-container-div">
            <Container className="main-container card3-list-container">
                <h1 className="card-list-header clients-opnions-h">
                    {t("main.clients-opinions")}
                </h1>
                <Carousel
                    additionalTransfrom={0}
                    arrows
                    autoPlaySpeed={3000}
                    centerMode={true}
                    className=""
                    containerClass="container"
                    dotListClass=""
                    draggable
                    focusOnSelect={false}
                    infinite={false}
                    itemClass=""
                    keyBoardControl
                    minimumTouchDrag={80}
                    pauseOnHover
                    renderArrowsWhenDisabled={false}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={false}
                    responsive={responsive}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl={true}
                    shouldResetAutoplay
                    showDots
                    sliderClass=""
                    slidesToSlide={1}
                    swipeable
                >
                    {clientsOpinions.map((i) => (
                        <div className="client-card">
                            <div className="client-card-data">
                                <div className="client-sm-div">
                                    <img
                                        src={i.pic}
                                        alt={`${i.name} profile picture`}
                                        className="client-card-img"
                                    />
                                    <p className="client-card-name">{i.name}</p>
                                </div>
                                <div className="client-star-div">
                                    <div className="stars-div">
                                        {[...Array(i.stars)].map(() => (
                                            <img
                                                src={goldStar}
                                                alt="star"
                                                className="card-star"
                                            />
                                        ))}
                                        {[...Array(5 - i.stars)].map(() => (
                                            <img
                                                src={star}
                                                alt="star"
                                                className="card-star"
                                            />
                                        ))}
                                    </div>
                                    <img
                                        src={dQoute}
                                        alt="icon"
                                        className="client-comment-img"
                                    />
                                </div>
                            </div>
                            <div className="client-card-comment">
                                {i.comment}
                            </div>
                        </div>
                    ))}
                </Carousel>
            </Container>
        </div>
    );
};

export default ClientsOpinions;
